/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const recordPlayInstallReferrerV1BodySchema = z.object({
  deviceId: z.string(),
  installReferrer: z.string(),
  installBeginTimestamp: z.number().nullable(),
  referrerClickTimestamp: z.number().nullable(),
  capturedAt: z.number(),
});

export type IRecordPlayInstallReferrerV1Body = z.infer<
  typeof recordPlayInstallReferrerV1BodySchema
>;
